export default function ReportBuilderController() {}
